import React, { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import cn from 'classnames';

import LoginForm from '../../../components/common/forms/LoginForm';
import Input from '../../../components/form/Input';
import Button from '../../../components/common/ui/Button';
import fetchRequest from '../../../utils/fetchRequest';
import { SELECT_SUB } from '../ActivationWizard/screenTypes';

import styles from './styles.module.scss';

const RequestDeviceSnForm = ({ setDeviceData, setStep }) => {
  const [searchParams, setSearchParams] = useSearchParams();

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [deviceSn, setDeviceSn] = useState(searchParams.get('device_sn') || '');
  const disabled = deviceSn.trim().length < 16;

  const handleRequestDeviceSn = async (deviceSn) => {
    setLoading(true);
    setError('');
    let deviceResponse = null;
    try {
      let response = await fetchRequest.get('/devices/get_device_info_by_sn', {
        device_sn: deviceSn,
      });

      deviceResponse = response?.data?.device;
    } catch (e) {
      if (!navigator.onLine) {
        setError('Network error. Please, check your connection');
      } else {
        setError('The device serial number is incorrect');
      }
    } finally {
      setLoading(false);
      if (deviceResponse?.plan_info === null) {
        setDeviceData({
          deviceSn,
          device: deviceResponse,
        });
        setStep(SELECT_SUB);
        setError('');
      } else if (
        deviceResponse?.status === 'active' &&
        deviceResponse?.plan_info
      ) {
        setError(
          'This device is already active. Please make sure that you provided correct device number or contact customer support for assistance.',
        );
      } else {
        setError('The device serial number is incorrect');
      }
    }
  };

  const handleChange = (event) => {
    setDeviceSn(event.target.value);
  };

  const handleSubmit = (e) => {
    handleRequestDeviceSn(deviceSn.trim().toLowerCase());
    setSearchParams({});
    e.preventDefault();
  };

  return (
    <LoginForm
      title={'Device Activation'}
      submitHandle={handleSubmit}
      type={'requestDeviceSn'}
    >
      <Input
        required
        type="text"
        name="serial_number"
        placeholder="Serial Number of Your Device"
        onChange={handleChange}
        value={deviceSn}
      ></Input>
      {error && <p className={cn('text-error', styles.error)}>{error}</p>}
      <Button disabled={disabled} type={'submit'} isLoading={loading}>
        <span>Next</span>
      </Button>
    </LoginForm>
  );
};
export default RequestDeviceSnForm;
